export default {"src":"/assessments/student/_next/static/media/smiley-illustration.047d43bb.svg","height":224,"width":228,"blurWidth":0,"blurHeight":0};